module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "teacher"
    }
  }, [_c('section', {
    staticClass: "wmtg"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们为您提供")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-zntk.png"),
      "alt": "智能题库"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("智能题库")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("知心慧学为您提供内容丰富的动态智能题库。它分类详细，各类题目一应俱全；试题每日更新，每道都详细标注了知识点、考点属性。大量教师精编套卷、自主研发套卷，全面满足您的组卷需求！")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-yjxt.png"),
      "alt": "阅卷系统"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("阅卷系统")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("同时支持网上阅卷和纸笔阅卷，客观题自动批阅，两种阅卷方式均不需要人工统分，系统自动统计。在不改变批改习惯的前提下，助您提升阅卷效率，事半功倍！")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-jxb.png"),
      "alt": "教学宝"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("教学宝")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("我们在每次考试结束之后为您打印“教学宝”，将答题详情、学情统计、学生成绩动态跟踪表、班级变式训练题等整理成册。是您进行科学备课、精准讲评、个性化教学的必备神器。")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": require("../assets/img/img-xqtj.png"),
      "alt": "学情统计"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-name"
  }, [_vm._v("学情统计")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("系统自动收集记录每次考试的详细答题数据，智能分析班级考试学情，分析每道试题的答题情况，自动记录每个知识点的历次得分情况。班级学情统计跃然于纸，一目了然！")])])])]), _vm._v(" "), _c('section', {
    staticClass: "wmdcp"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("我们的产品")]), _vm._v(" "), _c('i', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "img-chanping",
    attrs: {
      "src": require("../assets/img/img-chanping.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-line-2",
    attrs: {
      "src": require("../assets/img/img-line-2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "jsd"
  }, [_vm._v("教师端")]), _vm._v(" "), _c('img', {
    staticClass: "img-line-1",
    attrs: {
      "src": require("../assets/img/img-line-1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "jxb"
  }, [_vm._v("教学宝")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75c46892","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Teacher.vue
// module id = 543
// module chunks = 2